export const fontScale = function() {
  return 96 / 72;
}